import { render, staticRenderFns } from "./user_counts.vue.js?vue&type=template&id=41b15da4!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_counts.vue?vue&type=template&id=41b15da4"
import script from "./user_counts.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_counts.vue?vue&type=script&lang=js"
export * from "./user_counts.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_counts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41b15da4')) {
      api.createRecord('41b15da4', component.options)
    } else {
      api.reload('41b15da4', component.options)
    }
    module.hot.accept("./user_counts.vue.js?vue&type=template&id=41b15da4!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_counts.vue?vue&type=template&id=41b15da4", function () {
      api.rerender('41b15da4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "super_sidebar/components/user_counts.vue"
export default component.exports